module.exports = __webpack_public_path__ + "img/cursor.fa71807c.svg";